import type { ReactElement, ReactNode } from 'react'
import styles from './StationFactRow.module.css'

interface Props {
  /** Leading 46px icon cell (Figma glyph column). */
  icon: ReactNode
  /** Small grey label, e.g. `Address`. */
  label: string
  /** Bold value line. */
  value: string
  /**
   * Value colour override — the design greys out `Not available`
   * (#c0c0c0) and paints the live service state (green #3d9e5c);
   * default is the ink #1c1c1e.
   */
  tone?: 'default' | 'muted' | 'good' | 'advisory' | 'closure'
}

/**
 * One row of the Overview facts list — Figma 8597:44629: 84px row,
 * icon column, grey 16px label over bold 19.5px value, #f2f0ec
 * hairline separator.
 */
export function StationFactRow({ icon, label, value, tone = 'default' }: Props): ReactElement {
  return (
    <div className={styles.row}>
      <div className={styles.icon} aria-hidden="true">
        {icon}
      </div>
      <div className={styles.textColumn}>
        <p className={styles.label}>{label}</p>
        <p className={`${styles.value} ${styles[`tone-${tone}`]}`}>{value}</p>
      </div>
    </div>
  )
}
